import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat } from 'utils';
import { Notice } from './ui';

export default function HoldenEdit({ time }) {
  return (
    <Notice tone="hinweis" title="Deine Änderungen werden geprüft">
      Eingereicht am {moment.unix(time).format(dateFormat)}.
    </Notice>
  );
}

HoldenEdit.propTypes = {
  time: PropTypes.number.isRequired,
};
